<template>
    <div class="checkbox" :class="{'checkbox--checked': checked, 'checkbox--error': hasError}">
        <div class="checkbox__container">
            <input class="checkbox__input"
                   type="checkbox"
                   :id="name"
                   :name="name"
                   v-model="checked"
                   :required="required"
                   v-validate="rules">
        </div>
        <label class="checkbox__label" v-html="label" :for="name" :class="{'checkbox__label--small' : small}"></label>
    </div>
</template>
<script>
    export default {
        props: {
            label: String,
            name: String,
            required: {
                type: Boolean,
                default: false
            },
            value: Boolean,
            emitFromParent: {
                type: Boolean,
                default: true
            },
            small: Boolean
        },
        data() {
            return {
                checked: false,
                hasError: false,
                valueChanged: false,
            }
        },
        watch: {
            checked: function(checked) {
                if (checked) {
                    this.hasError = false;
                }

                if (!this.valueChanged || this.emitFromParent) {
                    this.$emit('input', checked);
                }

                this.valueChanged = false;
            },
            value: function(value) {
                this.valueChanged = true;
                this.checked = value;
            }
        },
        computed: {
            rules: function() {
                return this.required ? 'required' : '';
            }
        },
        methods: {
            validate: function() {
                return this.$validator.validate().then((result) => {
                    this.hasError = !result;

                    return result;
                });
            }
        },
        mounted() {
            this.valueChanged = true;
            this.checked = this.value;
        }
    }
</script>
<style lang="scss">
</style>